
import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';

interface ProtectedRouteProps {
  children: ReactNode;
  requiredRole?: string[];
}

export default function ProtectedRoute({ children, requiredRole }: ProtectedRouteProps) {
  const { user, userProfile, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <p className="text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Check role-based access if requiredRole is specified
  if (requiredRole && userProfile) {
    const userRole = userProfile.role;
    if (!requiredRole.includes(userRole)) {
      // Redirect PH Retention users to employee dashboard if they try to access unauthorized pages
      if (userRole === 'ph_retention') {
        return <Navigate to="/employee-dashboard" replace />;
      }
      // For other unauthorized users, redirect to login
      return <Navigate to="/login" replace />;
    }
  }

  return <>{children}</>;
}